// extracted by mini-css-extract-plugin
export default {"DatePickerFloating":"pVHNsAg4Hu79tEjBUqLE"};